



























































































import Vue from 'vue';
import { API, Auth } from "aws-amplify";
import { Constants } from "@/api-constants";

export default Vue.extend({

  name: 'FabFeedback',

  components: {
  },

  props: {
    // status: {
    //   type: String,
    //   default: 'ok',
    //   required: false,
    //   validator: (value) => {
    //     return [
    //       'ok',
    //       'loading',
    //       'syncing',
    //       'synced',
    //       'version-conflict',
    //       'error'
    //     ].indexOf(value) !== -1
    //   }
    // },
  },

  data() {
    return {
      valid:       false,
      dialog:      false,
      showMessage: false,
      formSubject: '' as any,
      ruleSubject: [
                     (v: any) => !!v || '"One-line Summary" is required',
                     (v: any) => (v && v.length <= 100) || '"One-line Summary" must be less than 100 characters',
                   ],
      formBody:    '' as any,
      ruleBody:    [
                     (v: any) => !!v || '"Description" is required',
                     (v: any) => (v && v.length <= 500) || '"Description" must be less than 500 characters',
                   ],
      formType:    '' as any,
      ruleType:    [
                     (v: any) => !!v || '"Feedback Type" is required',
                   ],
      formTypes:   [
                     {text: 'General', value: 'GENERAL'},
                     {text: 'Site Issue', value: 'ISSUE'},
                     {text: 'Feature Request', value: 'FEATURE_REQUEST'},
                   ],
    };
  },
  
  created() {
  },

  mounted() {
  },

  updated() {
    // console.log(this.$refs.form);
  },

  watch: {
    // routeName(newVal, oldVal) {
    //   if (newVal === 'mls') {
    //     this.showFavourites = false;
    //   }
    //   if (newVal === 'favourites') {
    //     this.showFavourites = true;
    //   }
    // },
  },

  computed: {  
    isLoggedIn(): any {
      return this.$store.getters.getIsLoggedIn;
    },
    isFormValid(): boolean {
      if (this.formBody && this.formSubject && this.formType && this.valid) {
        return true;
      } else {
        return false;
      }
    },
    feedbackForm(): Vue & { reset: () => void } {
      return this.$refs.form as Vue & { reset: () => void }
    },
  },

  methods: {

    sendFeedback() {
      this.showMessage = true;
      const path: any = '/core/feedback/'
        + this.$store.getters.getPackageId;
      const myInit: {} = {
        body: { 
          subject: this.formSubject,
          body:    this.formBody,
          type:    this.formType
        }
      };
      API.post(Constants.API_NAME, path, myInit)
        .then(response => {
          console.log('[ sendFeedback RESPONSE ]');
          console.log(response);
          this.clearForm();
        })
        .catch(error => {
          console.log('[ sendFeedback ERROR ]');
          console.log(error);
        })
        .finally( () => {
          setTimeout(() => this.showMessage = false, 1900);
          setTimeout(() => this.dialog = false, 2000);
       });
    },

    clearForm(): void {
      this.feedbackForm.reset();
    }

  },


});

